<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "@/iconfont/iconfont.css";
import navigation from "@/components/navigation_bar/navigation_bar";

export default {
  name: "App",

  data() {
    return { };
  },

  created() {},
  updated(e) {},
  watch: {
    $route: function (newVal, oldVal) {},
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;

  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
body {
  padding: 0;
  margin: 0 0 50px 0;
  background: #f8f9fa;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.manager_box,
.main {
  min-width: 1020px;
  margin-top: 68px;
  margin-left: 181px;
  padding: 20px;
  box-sizing: border-box;
  background: #ffff;
  width: calc(100% - 181px);
  border-radius: 4px;
  /* box-shadow: 0 0 6px rgba(0, 0, 0, 0.08); */
  background: #f8f9fa;
}
.target_setting_input input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
/* 火狐 */
.target_setting_input input[type="number"] {
  -moz-appearance: textfield;
}
.el_table_class .el-dialog {
  min-width: 600px;
}
.el_input_width .el-input--small .el-input__inner {
  min-width: 400px;
}

.el-menu-item.el-menu-item_t.is-active {
  /* background: #0a1e39 !important; */
  /* color: #fff !important; */
}
/* .el-menu--horizontal > .el-submenu .el-submenu__title {
  background: #0a1e39 !important;
  color: #ccc;
  font-size: 16px;
}
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: #0a1e39 !important;
  color: #fff !important;
}
.el-menu--horizontal ul li {
  background: #0a1e39 !important;
  color: #ccc;
}
.el-menu--horizontal ul li:hover {
  background: #0a1e39 !important;
  color: #fff !important;
}
.el-menu-item_t {
  /* background: #0a1e39 !important; */
/* color: hsla(0, 0%, 100%, 0.55); */
/* } */

.el-menu-item_t:hover {
  /* background: #0a1e39 !important; */
  /* color: #fff !important; */
}
*/ .el-table .warning-row {
  background: #f0f9eb;
}
.el-table .connected-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f4f4f5;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  margin: 6px 0;
  width: 80%;
  min-width: 300px;
}

.cont_date_picker {
  width: 200px;
}
.cont_date_picker .el-date-editor.el-input {
  /* width: 80%; */
  min-width: 200px;
}
.time_80 .el-date-editor.el-input {
  width: 100%;
}

.border_el_date_picker .el-date-editor {
  width: 100px;
}

.manager_box .el-table .cell {
  line-height: 44px;
}
.el-message-box {
  display: inline-block;
  width: 604px !important;
  padding-bottom: 16px !important;
  vertical-align: middle;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.el-message-box__header {
  padding: 26px 15px 10px !important;
}
.el-message-box__title {
  font-weight: bold !important;
  font-size: 36px !important;
  text-align: center;
}
*::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px;
}
*::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(77, 77, 77, 0.2);
  background: #6b6b6b;
}
*::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(90, 90, 90, 0.2);
  border-radius: 10px;
  background: #f6f6f6;
}
</style>



// WEBPACK FOOTER //
// src/App.vue